import Layout from "@/components/Layout";
import Home from "./Home";

const Index = () => {
  return (
    <Layout>
      <Home />
    </Layout>
  );
};

export default Index;
